import { Copy } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export default function DuplicarZonaMenu({ tramos, onDuplicarDia, onDuplicarTramo, className = "" }) {
  if (!tramos?.length || (!onDuplicarDia && !onDuplicarTramo)) return null;

  return (
    <div className={`mt-1 flex justify-end ${className}`}>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button
            type="button"
            title="Duplicar día o zona"
            className="inline-flex items-center gap-1 rounded border border-fuchsia-200 bg-fuchsia-50 px-1.5 py-0.5 text-[8px] font-medium text-fuchsia-700 transition-colors hover:bg-fuchsia-100 data-[state=open]:bg-fuchsia-100"
          >
            <Copy className="h-2.5 w-2.5" />
            Duplicar
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="min-w-[10rem]">
          <DropdownMenuLabel className="text-[10px] font-normal text-zinc-500">¿Qué copiar?</DropdownMenuLabel>
          {onDuplicarDia && (
            <DropdownMenuItem className="text-xs" onClick={onDuplicarDia}>
              <Copy className="mr-2 h-3.5 w-3.5 text-fuchsia-600" />
              Día completo
              <span className="ml-auto text-[10px] text-zinc-400">{tramos.length} tramo{tramos.length !== 1 ? "s" : ""}</span>
            </DropdownMenuItem>
          )}
          {onDuplicarDia && onDuplicarTramo && tramos.length > 0 && <DropdownMenuSeparator />}
          {onDuplicarTramo && tramos.map((t) => (
            <DropdownMenuItem key={t.id} className="text-xs" onClick={() => onDuplicarTramo(t)}>
              <span className="mr-2 h-2 w-2 shrink-0 rounded-full" style={{ backgroundColor: t.zona_color }} />
              {t.zona_nombre}
              <span className="ml-auto text-[10px] text-zinc-400">
                {t.hora_inicio?.slice(0, 5)}–{t.hora_fin?.slice(0, 5)}
              </span>
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
